<template>
  <div>
    <h1 class="page-header">
      {{ $t('accounting.rate_information_feature.rate_information') }}
    </h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create @fetch_data="fetchData"></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px;"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template v-slot="{ record }">
              <td>
                {{
                  record.from_currency.currency_name_en +
                    '|' +
                    record.from_currency.currency_code
                }}
              </td>
              <td>
                {{
                  record.to_currency.currency_name_en +
                    '|' +
                    record.to_currency.currency_code
                }}
              </td>
              <td class="text-center">{{ record.rate_amount }}</td>
              <td class="text-center">{{ record.fee_addon }}</td>
              <td class="text-center">
                <span
                  class="text-success"
                  v-tooltip="$t('accounting.rate_information_feature.active')"
                  v-if="record.is_active"
                  ><i class="fa fa-check"></i
                ></span>
                <span
                  class="text-danger"
                  v-tooltip="$t('accounting.rate_information_feature.deactive')"
                  v-else
                  ><i class="fas fa-exclamation-circle"></i
                ></span>
              </td>
              <td class="text-center">
                <a
                  href="#"
                  v-tooltip="$t('edit')"
                  class="text-primary mr-3"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="$t('delete')"
                  class="text-danger"
                  @click.prevent="destroy(record.rate_id)"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'rate-information',
  data() {
    return {
      loading: false,
      route_leave: false
    }
  },
  computed: {
    ...mapState('rateInformation', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.rateInformation.search
      },
      set(newVal) {
        this.$store.commit('rateInformation/SET_SEARCH', newVal)
        this.$store.commit('rateInformation/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('accounting.rate_information_feature.from_currency')
        },
        {
          name: this.$t('accounting.rate_information_feature.to_currency')
        },
        {
          name: this.$t('accounting.rate_information_feature.rate_amount'),
          style: 'width: 10%;text-align:center'
        },
        {
          name: this.$t('accounting.rate_information_feature.fee_addon'),
          style: 'width: 10%;text-align:center'
        },
        {
          name: this.$t('accounting.rate_information_feature.status'),
          style: 'width: 10%;text-align:center'
        },
        {
          name: this.$t('accounting.rate_information_feature.action'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('rateInformation/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(record) {
      this.$store.commit('rateInformation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'rate-information-edit',
        params: { id: record.rate_id }
      })
    },

    async destroy(id) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        this.$store
          .dispatch('rateInformation/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'rate-information') {
      this.$store.commit('rateInformation/RESET_STATE')
      this.$store.commit('rateInformation/SET_CURRENCIES', [])
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
